import { JobList } from 'packages/job_lists/JobList';
import { EntityBuilder } from '@decahedron/entity';
export var getters = {
    getHeroImage: function (state, _, rootState) { return function (jobList) {
        if (jobList.appearance && jobList.appearance.heroImage) {
            return jobList.appearance.heroImage;
        }
        return rootState.companySettings.branding ? rootState.companySettings.branding.heroImage : null;
    }; },
    getLogo: function (state, _, rootState) { return function (jobList) {
        if (jobList.appearance && jobList.appearance.logo) {
            return jobList.appearance.logo;
        }
        return rootState.companySettings.branding ? rootState.companySettings.branding.logo : null;
    }; },
    getJobList: function (state) { return function (jobListId) {
        var jobList = state.jobLists.find(function (jobList) { return jobList.id === jobListId; });
        return jobList ? EntityBuilder.buildOne(JobList, jobList.toJson()) : jobList;
    }; },
    hasActiveJobList: function (state) { return state.jobLists.some(function (jobList) { return !!jobList.published; }); },
};
